import { useLuckySpins } from '@/api/lucky-spins';
import { useMemo } from 'react';
import { useSearchParams } from './useSearchParams';

export function useLuckySpinWithSelectedSpin() {
  const search = useSearchParams();
  const mode = (search.get('mode') as string) ?? '1';

  const { luckySpins, error, isLoading, refetch } = useLuckySpins();

  const luckySpin = useMemo(
    () =>
      luckySpins?.data?.find(
        luckySpin => Number(luckySpin?.id) == Number(mode),
      ),
    [mode, luckySpins],
  );

  return {
    mode,
    error,
    refetch,
    luckySpin,
    isLoading,
    luckySpins,
  };
}
